import { Dispatch, SetStateAction } from "react";

type TPathConvertClassName = {
  pathname: string;
  signupCheckDivision: string;
  setCheckClass: Dispatch<SetStateAction<string>>;
  setTermsClass: Dispatch<SetStateAction<string>>;
};

export const pathConvertClassName = ({
  pathname,
  signupCheckDivision,
  setCheckClass,
  setTermsClass,
}: TPathConvertClassName) => {
  if (pathname === "/") {
    setCheckClass("main-chkbox");
    setTermsClass("main-fullterms");
    return;
  }
  if (pathname === "/building-remodeling") {
    setCheckClass("remodeling-chkbox");
    setTermsClass("remodeling-fullterms");
    return;
  }

  if (pathname === "/new-building") {
    setCheckClass("newbuilding-chkbox");
    setTermsClass("newbuilding-fullterms");
    return;
  }

  if (pathname === "/enterprise-energy") {
    setCheckClass("enterpriseenergy-chkbox");
    setTermsClass("enterpriseenergy-fullterms");
    return;
  }

  if (pathname === "/inquiry") {
    setCheckClass("inquiry-chkbox");
    setTermsClass("inquiry-fullterms");
    return;
  }

  if (pathname === "/project-request") {
    setCheckClass("projectrequest-chkbox");
    setTermsClass("projectrequest-fullterms");
    return;
  }

  if (pathname === "/signup") {
    if (signupCheckDivision === "indivisualSignUpTerms") {
      setCheckClass("signup-normal-signuptermschkbox");
      setTermsClass("signup-normal-signupfullterms");
      return;
    } else if (signupCheckDivision === "corporationSignUpTerms") {
      setCheckClass("signup-corporation-signuptermschkbox");
      setTermsClass("signup-corporation-signupfullterms");
      return;
    }

    if (signupCheckDivision === "indivisualPrivacyPolicyTerms") {
      setCheckClass("signup-normal-privateinfochkbox");
      setTermsClass("signup-normal-privateinfofullterms");
      return;
    } else if (signupCheckDivision === "corporationPrivacyPolicyTerms") {
      setCheckClass("signup-corporation-privateinfochkbox");
      setTermsClass("signup-corporation-privateinfofullterms");
      return;
    }

    if (signupCheckDivision === "indivisualIsMarketing") {
      setCheckClass("signup-normal-marketingchkbox");
      return;
    } else if (signupCheckDivision === "corporationIsMarketing") {
      setCheckClass("signup-corporation-marketingchkbox");
      return;
    }
  }
};
